import {
  tsGetSampleRun,
  tsGetScreenCollection,
} from '../../Typescript/API_Response'
import { useMessagePopupContext } from '../../garvan-react/Components/ModalFeedback/MessagePopup'
import { useMutation, useQuery } from 'react-query'
import { AxiosResponse } from 'axios'
import { useUserContext } from '../../Contexts/UserConfig'
import ScreenCollectionService from '../PHP/APIs/ScreenCollectionService'

export function useGetScreenCollection(
  collection_id: undefined | string | number,
) {
  const { whoAmI } = useUserContext()
  const { setError, setMessage } = useMessagePopupContext()
  return useQuery<tsGetScreenCollection | any, AxiosResponse>(
    ['ScreenCollectionService', 'getScreenCollection', collection_id],
    () => ScreenCollectionService.getScreenCollection(whoAmI!, collection_id!),
    {
      enabled: !!whoAmI && !!collection_id,
      onError: (err) => setError(err),
      onSuccess: (data) => {
        if (!data?.Collection) {
          setMessage({
            subject: 'Error getting screen collection',
            message: (data as any)?.message,
            severity: 'warning',
          })
        }
      },
    },
  )
}

export function useUpdateScreenCollectionStatus(
  collection_id: undefined | string | number,
) {
  const { whoAmI } = useUserContext()
  const { setError, setMessage } = useMessagePopupContext()
  return useMutation<any, AxiosResponse, string, () => void>(
    (status) =>
      ScreenCollectionService.updateScreenCollectionStatus(
        whoAmI!,
        collection_id!,
        status,
      ),
    {
      onError: (err) => setError(err),
      onSuccess: async (data) => {
        if (data?.message) {
          setMessage({
            subject: 'Unable to update status',
            message: data.message,
            severity: 'warning',
          })
        }
      },
    },
  )
}

export function useGetScreenCollectionSampleRuns(
  collection_id: undefined | string | number,
) {
  const { whoAmI } = useUserContext()
  const { setError } = useMessagePopupContext()
  return useQuery<tsGetSampleRun[] | any, AxiosResponse>(
    ['ScreenCollectionService', 'getScreenCollectionSampleRuns', collection_id],
    () =>
      ScreenCollectionService.getScreenCollectionSampleRuns(
        whoAmI!,
        collection_id!,
      ),
    {
      enabled: !!whoAmI && !!collection_id,
      onError: (err) => setError(err),
      select: (data) => data?.SampleRuns,
    },
  )
}
